import {Body1, Spinner} from "@fluentui/react-components";
import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {EnvPolicyValueObject} from "../../../data/value-object/env/EnvPolicyValueObject";
import {useEffect} from "react";
import {EnvPolicyIO} from "../../../io/EnvIO";
import {DetailDefaultPanel, DetailDefaultTab} from "../../DetailViews";
import {EnvPolicyDomain} from "../../../data/domain/env/EnvPolicyDomain";
import {EnvPolicyDescriptor} from "../../../data/descriptor/env/EnvPolicyDescriptor";
import {EnvPolicyDescription} from "../../../data/description/env/EnvPolicyDescription";

export default function Detail(props: RouterProps) {
    const params = useParams<{ envPolicyId: string }>()
    const item = useStatePair<EnvPolicyValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.envPolicyId !== undefined) {
            EnvPolicyIO
                .getById(BigInt(params.envPolicyId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: EnvPolicyValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={EnvPolicyIO}
                description={EnvPolicyDescription}
                properties={props => <PropertyBody {...props} />}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof EnvPolicyDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "envAdminPageSize":
        case "envAgreementPageSize":
        case "envBankPageSize":
        case "envEventPageSize":
        case "envNoticePageSize":
        case "envClientPageSize":
        case "envConstructionPageSize":
        case "envCountryPageSize":
        case "envCountryRankDuration":
        case "envFaqPageSize":
        case "envFaqItemPageSize":
        case "envPhoneBlockPageSize":
        case "envPolicyPageSize":
        case "envStorageKeyPageSize":
        case "lastModifiedAt":
        case "createdAt":
            return <Body1>{EnvPolicyDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{EnvPolicyDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}